module.exports = __webpack_public_path__ + "img/screen_3.b6da2346.jpg";